import { awsApiInstance } from '../api/aws-api';
import { comparePasswords } from '../helpers/helpers';
import { encryptData } from '../auth/encrypt-data';
import { cognitoError } from '../types/types';
import { resetPasswordBeforeSignUp } from './passwordreset';

/**
 * Registers a new user
 * 
 * @returns void
 */
const RegisterNewUser = async () => {
  const registerForm = document.querySelector('#aafp_signup-form') as HTMLFormElement;
  const regButton = document.querySelector('#register_button') as HTMLElement;
  const user = document.querySelector('#user_login') as HTMLInputElement;
  const code = document.querySelector('#aws_code') as HTMLInputElement;
  const resetKey = document.querySelector('#rp_key') as HTMLInputElement;
  const password = document.querySelector('#password') as HTMLInputElement;
  const confirmPassword = document.querySelector('#confirm_password') as HTMLInputElement;

  if ( !registerForm ) return;

  await cognitoResetPassword(user.value);

  registerForm.addEventListener('submit', async (event: Event) => {
    event.preventDefault();
    event.stopPropagation();

    if(registerForm.checkValidity()) {
      registerForm.classList.remove('was-validated');
      registerForm.classList.remove('form-control:valid');      

      cognitoError.innerHTML = '';

      try {
        await comparePasswords(password.value, confirmPassword.value);

        const formattedData = `${user.value}:${code.value}:${password.value}`;
        const token = encryptData(formattedData);

        const modalData = { 
          request: JSON.stringify(token)
        };

        await awsApiInstance.post('/auth/reset', modalData);

        regButton.classList.add('aafp_button-loading');
        await resetPasswordBeforeSignUp(resetKey.value, user.value, password.value);
      } catch ( error: any ) {
        cognitoError.innerHTML += `<p>${error.message}</p>`
        console.error(error);
      }
    } else {      
      registerForm.classList.add('was-validated');
    }
  });
}

/**
 * Sends a reset password request to AWS.  AWS sends a code to the user's email.
 * 
 * @param {string} user the user
 * 
 * @returns Promise
 */
const cognitoResetPassword = async (user: string) => {
  try {
    const key = encryptData(user);

    const modelData ={
      request: JSON.stringify(key)
    };

    const { data } = await awsApiInstance.post('/auth/email', modelData);

    return data;
  } catch ( error ) {
    console.log( error );
    cognitoError.innerHTML = '';
    cognitoError.innerHTML = `<p>Error Sending Verification code.  Please contact support.</p>`;
  }
}

export default RegisterNewUser;